import React from "react";
import { Redirect, Route } from "react-router-dom";
import RescoStorage from "../../../utils/rescoStorage";

const PublicRoute: React.FC<{
  component: React.FC;
  path: string;
  exact: boolean;
  protected: boolean;
}> = (props) => {
  return props.protected && RescoStorage.getSession() != null ? (
    <Redirect to="/" />
  ) : (
    <Route path={props.path} exact={props.exact} component={props.component} />
  );
};

PublicRoute.displayName = "PublicRoute";

export default PublicRoute;
